import Layout from "./components/Layout";
import Form from "./components/Form";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import Home from "./pages/Home";

function App() {
  return (
    <>
      <Router>
        <Layout>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/Create" element={<Form />} />
          </Routes>
        </Layout>
      </Router>
    </>
  );
}

export default App;
